import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_category",
  "use": "icon-ic_category-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-ic_category\">\n<path d=\"M53.5,78.8v10.8H69c1.9,0,3.5,1.6,3.5,3.5S71,96.6,69,96.6H31c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h15.5V78.8\n\tc-11.2-1.5-20.2-10-22.4-21h-4c-3.9,0-7-3.2-7-7V36.6c0-3.9,3.2-7,7-7h3.5v-3.4c0-3.9,3.2-7,7-7h38.7c3.9,0,7,3.2,7,7v3.4h3.5\n\tc3.9,0,7,3.2,7,7v14.1c0,3.9-3.2,7-7,7h-4C73.7,68.7,64.7,77.3,53.5,78.8z M23.6,36.6h-3.5v14.1h3.5V36.6z M76.4,36.6v14.1h3.5V36.6\n\tH76.4z M30.6,26.2v26.4c0,10.7,8.7,19.4,19.4,19.4s19.4-8.7,19.4-19.4V26.2H30.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ic_category.svg
// module id = YEm6
// module chunks = 1